// extracted by mini-css-extract-plugin
export default {"home_container":"Home_home_container__cASTx","btn":"Home_btn__3xLVW","whatsapp":"Home_whatsapp__PNaFV"};